import React, { Component } from "react";
import { connect } from "react-redux";
import Scrollbars from "react-custom-scrollbars";
import InfiniteScroll from "react-infinite-scroller";
import getMessages from "../../../../../_selectors/messagingSelectors/getMessages";
import * as messagingActions from "../../../../../_actions/messagingActions";
import { map } from "lodash";
import { getRelativeTime } from "../../../../../_utils";
import getIsLastResult from "../../../../../_selectors/messagingSelectors/getIsLastResult";
import getNewMessageAddedFlag from "../../../../../_selectors/messagingSelectors/getNewMessageAddedFlag";

class Messages extends Component {
  componentDidUpdate(prevProps) {
    if (this.props.newMessageAdded) {
      this.scrollbars.scrollToBottom();
    }
  }
  loadPreviousMessages = () => {
    const { messages, isLastResult, loadMore, messagingId } = this.props;
    if (messages.length === 0) {
      //nothing
    } else {
      loadMore({ lastResult: messages[0].id, messagingId });
    }
  };
  render() {
    const { messages, receiver, isLastResult } = this.props;
    return (
      <div class="chat-wrapper scroll">
        <Scrollbars
          autoHeight
          autoHeightMax={"calc(100vh - 245px)"}
          style={{ width: 300 }}
          onUpdate={values => {
            console.log(values);
          }}
          ref={scrollbars => (this.scrollbars = scrollbars)}
        >
          <InfiniteScroll
            pageStart={0}
            loadMore={this.loadPreviousMessages}
            hasMore={!isLastResult}
            loader={<div className="loader">Loading ...</div>}
            useWindow={false}
            isReverse={true}
            initialLoad={false}
          >
            <ul class="chat" id="rightbar_chat">
              {map(messages, messageItem => {
                return (
                  <li
                    className={
                      receiver === messageItem.sender ? "inbox" : "sent"
                    }
                    key={messageItem.id}
                  >
                    {messageItem.message}

                    <span> {getRelativeTime(messageItem.createdAt)}</span>
                  </li>
                );
              })}
            </ul>
          </InfiniteScroll>
        </Scrollbars>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  messages: getMessages(state),
  isLastResult: getIsLastResult(state),
  newMessageAdded: getNewMessageAddedFlag(state)
});
const mapDispatchToProps = dispatch => ({
  loadMore: payload => dispatch(messagingActions.loadPreviousMessages(payload))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Messages);



// WEBPACK FOOTER //
// ./src/_components/Layout/RightSidebar/Chat/Messages/index.js